import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=76316b12&scoped=true&"
var script = {}
import style0 from "./emptyData.vue?vue&type=style&index=0&id=76316b12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76316b12",
  null
  
)

export default component.exports